module.exports = __webpack_public_path__ + "static/palm_leaf-2a6d97cabcdb36c4bde10103646cc088.png";